import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import styles from "./Home.module.css";
import bgVideo from "../images/adn2_final.mp4";
import logo from "../images/medicina.png";

export default function Home({ setSplashVisible }) {
    const { user } = useContext(AuthContext);
    const [videoReady, setVideoReady] = useState(false);
    const [localSplashVisible, setLocalSplashVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (videoReady) {
                setLocalSplashVisible(false);
                setSplashVisible(false);
            }
        }, 3000);
        return () => clearTimeout(timer);
    }, [videoReady, setSplashVisible]);

    const handleVideoReady = () => {
        setVideoReady(true);
        setTimeout(() => {
            setLocalSplashVisible(false);
            setSplashVisible(false);
        }, 3000);
    };

    if (user) return <Navigate to="/courses" replace />;

    return (
        <div className={styles.hero}>
            {localSplashVisible && (
                <div className={styles.splash}>
                    <img src={logo} alt="Medicina Total" className={styles.splashLogo} />
                    <p className={styles.splashText}>Cargando...</p>
                    <div className={styles.loadingBar}>
                        <div className={styles.loadingProgress}></div>
                    </div>
                </div>
            )}

            <video
                className={styles.backgroundVideo}
                src={bgVideo}
                autoPlay
                muted
                loop
                onCanPlayThrough={handleVideoReady}
                style={{ display: localSplashVisible ? "none" : "block" }}
            />

            <div className={styles.overlay} />

            {!localSplashVisible && (
                <div className={styles.card}>
                    <h1 className={styles.title}>Bienvenido a Medicina Total</h1>
                    <p className={styles.subtitle}>
                        Explora nuestros cursos de Medicina con acceso seguro y contenido de calidad.
                    </p>
                    <ul className={styles.features}>
                        <li>Actualizaciones periódicas de contenidos</li>
                        <li>Acceso ilimitado a los materiales de por vida</li>
                        <li>Soporte y tutorías personalizadas</li>
                    </ul>
                    <p className={styles.info}>
                        Para adquirir un curso, por favor registrate, inicia sesión o contáctanos a{" "}
                        <a href="mailto:medicinatotal91@gmail.com">medicinatotal91@gmail.com</a>{" "}
                        o en Instagram{" "}
                        <a
                            href="https://instagram.com/medicina_total1"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            @medicina_total1
                        </a>
                        .
                    </p>
                </div>
            )}
        </div>
    );
}
